import { usePortalApi } from "api/setup";
import { ApiError } from "api/shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

export interface GetClientEnabledResponse {
  enabled: boolean;
}

export const useGetClientEnabledQuery = ({ manual = true } = {}) => {
  return usePortalApi<GetClientEnabledResponse, ApiError>(
    {
      url: formatUrl(api.companies.enabled),
    },
    {
      manual,
    }
  );
};
